/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["draft"] }] */
import { ServiceType } from '@/__generated__/globalTypes';
import { SearchCaregiversAction, SearchCaregiversState } from '@/types/searchCaregivers';
import produce from 'immer';

const caregiverLists = {
  caregiverPreview: {
    caregivers: [],
    hasFinishedUpdating: false,
  },
  caregiverRecap: {
    caregivers: [],
    hasFinishedUpdating: false,
  },
};

export const initialState: SearchCaregiversState = {
  childCare: caregiverLists,
  seniorCare: caregiverLists,
  caregiverZip: '',
};

export const searchCaregiversReducer = produce(
  (draft: SearchCaregiversState, action: SearchCaregiversAction) => {
    switch (action.type) {
      case 'setCaregiverPreview': {
        if (action.caregiverPreview.caregivers) {
          switch (action.vertical) {
            case ServiceType.SENIOR_CARE:
              draft.seniorCare.caregiverPreview.caregivers = action.caregiverPreview.caregivers;
              break;
            case ServiceType.CHILD_CARE:
              draft.childCare.caregiverPreview.caregivers = action.caregiverPreview.caregivers;
              break;
            default:
              break;
          }
        }
        switch (action.vertical) {
          case ServiceType.SENIOR_CARE:
            draft.seniorCare.caregiverPreview.hasFinishedUpdating =
              action.caregiverPreview.hasFinishedUpdating;
            break;
          case ServiceType.CHILD_CARE:
            draft.childCare.caregiverPreview.hasFinishedUpdating =
              action.caregiverPreview.hasFinishedUpdating;
            break;
          default:
            break;
        }

        return draft;
      }
      case 'setCaregiverRecap': {
        if (action.caregiverRecap.caregivers) {
          switch (action.vertical) {
            case ServiceType.SENIOR_CARE:
              draft.seniorCare.caregiverRecap.caregivers = action.caregiverRecap.caregivers;
              break;
            case ServiceType.CHILD_CARE:
              draft.childCare.caregiverRecap.caregivers = action.caregiverRecap.caregivers;
              break;
            default:
              break;
          }
        }
        switch (action.vertical) {
          case ServiceType.SENIOR_CARE:
            draft.seniorCare.caregiverRecap.hasFinishedUpdating =
              action.caregiverRecap.hasFinishedUpdating;
            break;
          case ServiceType.CHILD_CARE:
            draft.childCare.caregiverRecap.hasFinishedUpdating =
              action.caregiverRecap.hasFinishedUpdating;
            break;
          default:
            break;
        }

        return draft;
      }
      case 'setCaregiverZip': {
        draft.caregiverZip = action.caregiverZip;
        return draft;
      }
      default:
        return draft;
    }
  }
);

export const reducer = (state: SearchCaregiversState, action: SearchCaregiversAction) => {
  return searchCaregiversReducer(state, action as SearchCaregiversAction);
};
